// extracted by mini-css-extract-plugin
export default {"root":"detail-action-row_root__eVw3l"};